'use strict';

// external
import {keys} from 'ts-transformer-keys';

// shared imports
import {ItemAttributes} from '~/shared/src/ci/Item';
import {ReferenceAttributes} from '~/shared/src/ci/Reference';
import {BaseRequestParameters} from '~/shared/src/model/BaseRequest';
import {DataStructure} from '~/shared/src/utilities/dataStructure';
import {
    DynamicNode,
    TreeNode
} from '~/shared/src/utilities/treeViewNodes';
import {Message} from '~/shared/src/utilities/message';
import {Function} from '~/shared/src/utilities/function';
import {Condition} from '~/shared/src/utilities/condition';


/*** MetaModel types *************************************************************************************************/

// CFG:TreeView
export type TreeView = {
    data : {
        id : number;
        key : string;
        name? : string;

        active : boolean;
        description? : string;
    };
    dataStructure? : DataStructure;
    nodes? : ( TreeNode | DynamicNode )[];
    conditions? : {
        filter? : Condition;
    };
    functions? : Function[];
    messages? : {
        tabTitle? : Message;
        title? : Message;
        tooltipTitle? : Message;
    };
    images? : {
        icon? : string;
    };
};
export const treeViewDataProps = keys<TreeView['data']>();
export const treeViewConditions = keys<Required<TreeView>[ 'conditions' ]>() as string[];
export const treeViewImages = keys<Required<TreeView>[ 'images' ]>() as string[];
export const treeViewMessages = keys<Required<TreeView>[ 'messages' ]>() as string[];
export const requiredTreeViewProps = keys<RequiredOf<TreeView>>();
export const treeViewProps = keys<TreeView>();


/*** method types ****************************************************************************************************/

/*** loadConfig ***/
export type LoadConfigDataParameters = Partial<BaseRequestParameters> & ( {
    viewId : string;
    viewKey : string;
} );
export type LoadConfigDataResult = {
    success : boolean;
    data : {
        items : ItemAttributes[];
        references : ReferenceAttributes[];
    };
    metaData : {
        metrics : Metric[];

        // debug
        cypher? : string;
        sql? : string;
        parameters? : {
            [ parameter : string ] : any
        };
    };
};

export type GetTreeViewItemIdByDisplayAttributeParameters = {
    displayAttributeValue : string;
};
export type GetTreeViewItemIdByDisplayAttributeResult = {
    success : true;
    data : {
        rootItemId? : number;
    };
    metaData : {
        metrics : Metric[];

        // debug
        getTreeViewItemId? : {
            sql? : string;
            parameters? : {
                [ parameter : string ] : any
            };
        };
    };
};

export type GetViewKeyByNameParameters = {
    viewName : string;
};
export type GetViewKeyByNameResult = {
    success : true;
    data : {
        viewKey? : string;
    };
    metaData : {
        metrics : Metric[];

        // debug
        sql? : string;
        parameters? : { [ parameter : string ] : any };
    };
};

/*** deleteTreeView ***/
export type DeleteTreeViewParameters = {
    viewId : number;
    historizeOnly? : boolean;
};
export type DeleteTreeViewResult = {
    success : boolean;
    metaData : {
        metrics : Metric[];
    }
};
